import Cookies from "js-cookie";
import { BACKEND_URL, getHeaders, handleResponse } from "./utils";
import { TMessageCreate, TMessageUpdate } from "../types/chat";
import { MessageDto } from "../components/Chat/Services/socket-type";

export async function getDialogs() {
  try {
    const response = await fetch(`${BACKEND_URL}/chat/conversations/list`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    if (!response.ok) {
      if (response.status === 404) {
        return [];
      }
      throw new Error(`Error: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error get messages:", error);
    throw error;
  }
}
//получение сообщений для чата
export async function getMessagesForConversation(
  idConversation: number,
): Promise<{ messages: MessageDto[]; total: number }> {
  try {
    const response = await fetch(
      `${BACKEND_URL}/chat/messages/${idConversation}`,
      {
        method: "GET",
        headers: getHeaders(Cookies.get("accessToken")),
      },
    );

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get messages:", error);
    throw error;
  }
}

export async function getNewMessage(userId: number) {
  try {
    const response = await fetch(
      `${BACKEND_URL}/chat/conversations/${userId}`,
      {
        method: "GET",
        headers: getHeaders(Cookies.get("accessToken")),
      },
    );

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get messages:", error);
    throw error;
  }
}

//Отправка сообщения
export async function addMessages(message: TMessageCreate) {
  try {
    const response = await fetch(`${BACKEND_URL}/chat/messages`, {
      method: "POST",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(message),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error add messages:", error);
    throw error;
  }
}

//Редактирование сообщения
export async function editeMessage(message: TMessageUpdate, id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/chat/messages/${id}`, {
      method: "PATCH",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(message),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error add messages:", error);
    throw error;
  }
}

//Удаление сообщения
export async function deleteMessage(id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/chat/${id}/delete`, {
      method: "DELETE",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error delete messages:", error);
    throw error;
  }
}

export async function uploadPhoto(formData: FormData) {
  try {
    const response = await fetch(`${BACKEND_URL}/chat/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
      },
      body: formData,
    });
    console.log("1111", response);
    return await handleResponse(response);
  } catch (error) {
    console.error("Error uploading photo:", error);
    throw error;
  }
}
